const servicios = [
    {id: 1,
    titulo: 'Protección de Marca',
    img: '/img/Servicios/protect.webp',
    texto: 'Nuestro servicio integral de protección de marca garantiza la reputación, imagen y control de precios de nuestros clientes. Preservamos la identidad y prestigio de una marca, desarrollando estrategias sólidas para enfrentar los desafíos del mercado actual.',
    cel: 541143993437,
    msg: 'Hola, estoy en interesado en averiguar por los servicios de Protección de Marca de Galidé.'
    },
    {id: 2,
    titulo: 'Redes Sociales',
    img: '/img/Servicios/mkt.webp',
    texto: 'Brindamos gestión completa de redes sociales. Administración de cuentas, creación de contenido innovador y atractivo para potenciar la presencia en redes. Confía en nosotros para impulsar tu marca y llegar a tu audiencia de manera efectiva.',
    cel: 541132535790,
    msg: 'Hola, estoy en interesado en averiguar por los servicios de Redes Sociales de Galidé.'
    },
    {id: 3,
    titulo: 'SEO y WEB',
    img: '/img/Servicios/seo.webp',
    texto: 'Impulsa tu presencia en línea con SEO y SEM. Optimizamos tu web con estrategias de búsqueda orgánica y gestionamos campañas publicitarias efectivas. Desarrolla tu web con tecnologías y lenguajes de programación modernos, funcionales y atractivos.',
    cel: 541143993437,
    msg: 'Hola, estoy en interesado en averiguar por los servicios de SEO-SEM y Desarrollo Web de Galidé.'
                },
    {id: 4,
    titulo: 'Identidad de Marca',
    img: '/img/Servicios/identidad.webp',
    texto: 'Construimos el ADN de tu marca, desde el concepto hasta la identidad visual. Tenemos en cuenta tu público objetivo y competencia para la creación de la misma. Nuestro desarrollo incluye arquetipos de diseño, naming, logotipo, slogan, paleta de colores y mucho más.',
    cel: 541132535790,
    msg: 'Hola, estoy en interesado en averiguar por los servicios de Identidad de Marca de Galidé.'
        }
]


export default servicios;